export default "__VITE_ASSET__BaNPz7fz__"